// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".containers[data-v-52de8a10] {\n  width: 100%;\n  margin: 0 auto;\n  height: calc(100vh);\n  overflow: hidden;\n  overflow-y: auto;\n}\n.containers .contexts[data-v-52de8a10] {\n  padding: 0px;\n  padding-top: 44px;\n}\n", ""]);
// Exports
module.exports = exports;
